import { renderToString } from 'react-dom/server';

import type { Message } from '../redux/messages/types';

export function getPlainMessage(text: Message['text']): string {
  if (typeof text === 'string') {
    return text;
  }
  if (Array.isArray(text)) {
    return text.join('\n');
  }
  return renderToString(text);
}
